/**
 * 活动配置信息
 */

let areaCode = {
    中东:"MSL",
    大陆:"CN",
    台湾:"TW", 
    香港:"HK",
    越南:"VN",
    日本:"JP",
    x:"GLOBAL",
    华语区:"Chinese",
    ZTXMA:"ZTXMA",
    中台港日:"ztgr",
    新加坡:"SG",
    中港越:"ZGY" ,
    马来西亚:"MALAI",
    印度尼西亚:"RID" ,
    韩国:"Korea", 
    印尼:"RID",
    USA:"USA",
    美国:"USA" 
};

Object.assign(UpAct.CONFIG, {
    // 活动ID｛String | Array｝。若不设置。默认获取的是URL参数acid=xxx
    acid: '',
    acidConfig:{
       acid: [{
            uniqueId: 'idol',
            text: '总榜',
            acid:[{
                uniqueId: 'idol-jajp',
                text: '日本',
                acid: [{
                    uniqueId: 'idol-jajp-zb',
                    text:'预赛总榜',
                    listType:'HostList',
                    listStyle: 'zb',
                    acid:1985,
                    areaCode: 'JP'
                },{
                    uniqueId: 'idol-js-zb',
                    text:'决赛总榜',
                    listType:'HostList',
                    listStyle: 'zb',
                    acid:1986,
                    areaCode: 'JP'
                },{
                    uniqueId: 'idol-jajp-sc',
                    text:'时长榜',
                    listType:'DurationList',
                    listStyle: 'zb',
                    acid:1987,
                    areaCode: 'JP'
                }]
            }]
        }]
    },
    
});

if(UpAct.BaseUtil.query('env') == 'stage'){
    UpAct.CONFIG.taskAcid = 124;
    UpAct.CONFIG.acidConfig = {
        acid: [{
            uniqueId: 'idol',
            text: '总榜',
            acid:[{
                uniqueId: 'idol-jajp',
                text: '日本',
                acid: [{
                    uniqueId: 'idol-jajp-sc',
                    text:'预赛总榜',
                    listType:'HostList',
                    listStyle: 'zb',
                    acid:100143,
                    areaCode: 'CN'
                },{
                    uniqueId: 'idol-jajp-zb',
                    text:'决赛总榜',
                    listType:'HostList',
                    listStyle: 'zb',
                    acid:100143,
                    areaCode: 'CN'
                },{
                    uniqueId: 'idol-jajp-sc',
                    text:'时长榜',
                    listType:'DurationList',
                    listStyle: 'zb',
                    acid:100173,
                    areaCode: 'CN'
                },]
            }]
        }]
        
    };
}


// WEBPACK FOOTER //
// ./js/config.js